import gql from 'graphql-tag'

import { PublicExpoSendVerificationCodeMutation } from '../../../types/api'

export const sendVerificationCodes = {
  mutation: gql`
    mutation publicExpoSendVerificationCode(
      $event: ID
      $email: String
      $firstName: String
      $visitor: ID
    ) {
      publicExpoSendVerificationCode(
        event: $event
        email: $email
        firstName: $firstName
        visitor: $visitor
      )
    }
  `,
  transformer: (response: PublicExpoSendVerificationCodeMutation) => {
    return response.publicExpoSendVerificationCode
  },
}
